export enum Actions {
  SET_AUTHENTICATION = 'SET_AUTHENTICATION',
  LOGIN_PENDING = 'LOGIN_PENDING',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGIN_ERROR = 'LOGIN_ERROR',
  CLEAN_ERROR = 'CLEAN_ERROR',
  SET_AUTH_ERROR = 'SET_AUTH_ERROR',
}
